<template>
  <div class="tariffs-skeleton">
    <div class="tariffs-skeleton__primary">
      <div class="tariffs-skeleton__primary-header">
        <div class="skeleton-pill skeleton-pill--type"></div>
        <div class="skeleton-pill skeleton-pill--status"></div>
      </div>
      <div class="skeleton-line skeleton-line--primary-title"></div>
      <div class="skeleton-line skeleton-line--primary-subtitle"></div>
      <div class="tariffs-skeleton__service-tags">
        <div class="tariffs-skeleton__service-tag" v-for="n in 3" :key="`service-${n}`">
          <div class="skeleton-circle skeleton-circle--service"></div>
          <div class="skeleton-line skeleton-line--service"></div>
        </div>
      </div>
      <div class="tariffs-skeleton__payment">
        <div class="skeleton-circle skeleton-circle--payment"></div>
        <div class="skeleton-line skeleton-line--payment"></div>
      </div>
    </div>

    <div class="tariffs-skeleton__secondary">
      <div class="tariffs-skeleton__secondary-header">
        <div class="skeleton-line skeleton-line--section-title"></div>
        <div class="tariffs-skeleton__scroll">
          <div class="skeleton-block skeleton-block--control"></div>
          <div class="skeleton-block skeleton-block--control"></div>
        </div>
      </div>
      <div class="tariffs-skeleton__cards">
        <div class="tariffs-skeleton__cards-item" v-for="n in 4" :key="`card-${n}`">
          <div class="skeleton-circle skeleton-circle--card"></div>
          <div class="skeleton-line skeleton-line--card-label"></div>
        </div>
      </div>
    </div>

    <div class="tariffs-skeleton__shortcuts">
      <div class="tariffs-skeleton__shortcut" v-for="n in 3" :key="`shortcut-${n}`">
        <div class="skeleton-circle skeleton-circle--shortcut"></div>
        <div class="skeleton-line skeleton-line--shortcut"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'widget-tariffs-skeleton'
}
</script>

<style scoped>
.tariffs-skeleton {
  display: flex;
  flex-direction: column;
  gap: 20px;
  border: 1px solid #e9f1f9;
  border-radius: 24px;
  padding: 24px;
  background: #ffffff;
  box-shadow: 0 12px 32px rgba(43, 89, 120, 0.12);
}

.tariffs-skeleton__primary {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.tariffs-skeleton__primary-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.tariffs-skeleton__service-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.tariffs-skeleton__service-tag {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  border-radius: 16px;
  background: #f7fafb;
  position: relative;
  overflow: hidden;
  flex: 0 1 auto;
}

.tariffs-skeleton__service-tag::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.4) 50%, rgba(255,255,255,0) 100%);
  animation: shimmer 1.6s infinite;
}

.tariffs-skeleton__service-tag > * {
  position: relative;
  z-index: 1;
}

.tariffs-skeleton__payment {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 4px;
}

.tariffs-skeleton__secondary {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.tariffs-skeleton__secondary-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.tariffs-skeleton__scroll {
  display: flex;
  gap: 8px;
}

.tariffs-skeleton__cards {
  display: flex;
  gap: 12px;
  overflow: hidden;
}

.tariffs-skeleton__cards-item {
  flex: 1 1 140px;
  min-width: 120px;
  max-width: 160px;
  border-radius: 16px;
  padding: 12px;
  background: #f7fafb;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  position: relative;
  overflow: hidden;
}

.tariffs-skeleton__cards-item::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.4) 50%, rgba(255,255,255,0) 100%);
  animation: shimmer 1.6s infinite;
}

.tariffs-skeleton__cards-item > * {
  position: relative;
  z-index: 1;
}

.tariffs-skeleton__shortcuts {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.tariffs-skeleton__shortcut {
  flex: 1 1 160px;
  min-width: 140px;
  border-radius: 16px;
  padding: 12px;
  background: #f7fafb;
  display: flex;
  align-items: center;
  gap: 12px;
  position: relative;
  overflow: hidden;
}

.tariffs-skeleton__shortcut::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.4) 50%, rgba(255,255,255,0) 100%);
  animation: shimmer 1.6s infinite;
}

.tariffs-skeleton__shortcut > * {
  position: relative;
  z-index: 1;
}

.skeleton-line,
.skeleton-circle,
.skeleton-pill,
.skeleton-block {
  position: relative;
  overflow: hidden;
  background: #eef3f7;
  border-radius: 12px;
}

.skeleton-block {
  border-radius: 14px;
}

.skeleton-line::after,
.skeleton-circle::after,
.skeleton-pill::after,
.skeleton-block::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.55) 50%, rgba(255,255,255,0) 100%);
  animation: shimmer 1.6s infinite;
}

.skeleton-pill--type {
  width: 140px;
  height: 22px;
  border-radius: 999px;
}

.skeleton-pill--status {
  width: 90px;
  height: 20px;
  border-radius: 999px;
}

.skeleton-line--primary-title {
  width: 240px;
  height: 24px;
  border-radius: 14px;
}

.skeleton-line--primary-subtitle {
  width: 200px;
  height: 16px;
}

.skeleton-circle--service {
  width: 40px;
  height: 40px;
  border-radius: 14px;
}

.skeleton-line--service {
  width: 80px;
  height: 14px;
}

.skeleton-circle--payment {
  width: 28px;
  height: 28px;
  border-radius: 10px;
}

.skeleton-line--payment {
  width: 210px;
  height: 16px;
}

.skeleton-line--section-title {
  width: 160px;
  height: 18px;
}

.skeleton-block--control {
  width: 40px;
  height: 40px;
  border-radius: 16px;
}

.skeleton-circle--card {
  width: 48px;
  height: 48px;
  border-radius: 16px;
}

.skeleton-line--card-label {
  width: 100px;
  height: 14px;
}

.skeleton-circle--shortcut {
  width: 40px;
  height: 40px;
  border-radius: 14px;
}

.skeleton-line--shortcut {
  flex: 1;
  height: 14px;
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
</style>
